export const GET_CALAMITIES = "GET_CALAMITIES";
export const FILTER_CALAMITIES = "FILTER_CALAMITIES";
export const ADD_CALAMITIE = "ADD_CALAMITIE";
export const EDIT_CALAMITIE = "EDIT_CALAMITIE";
export const GET_CALAMITIE = "GET_CALAMITIE";
export const RESET_CALAMITIE = "RESET_CALAMITIE";
export const CALAMITIES_ERROR = "CALAMITIES_ERROR";
